/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import HexGroup from 'solis/type/hex/group';


export default class SectorVariant
{
  constructor (group)
  {
    this.group = new HexGroup(group).normalize();

    this.canonicalize(this.group);
  }


  canonicalize (group)
  {
    this.key = group.toString();

    for (let i = 1; i < 6; ++i)
    {
      const candidateGroup = group.rotateRight(i).normalize();

      const candidateKey = candidateGroup.toString();

      if (candidateKey < this.key)
      {
        this.key = candidateKey;
        this.group = candidateGroup;
      }
    }
  }


  advance (element)
  {
    return new SectorVariant([ ...this.group, element ]);
  }


  getVariantNeighbors ()
  {
    return this.group.getNeighborsWithFilter( (candidate, count, all) =>
    {
      // Candidate needs at least 2 connections to the existing group.
      if (count < 2)
      {
        return false;
      }

      // Candidate future neighbors need to preserve at least 2 connections to outside of the group.
      for (const candidateNeighbor of candidate.getNeighbors())
      {
        if (all.contains(candidateNeighbor))
        {
          if (all.get(candidateNeighbor).data >= 4)
          {
            return false;
          }
        }
      }

      return true;
    });
  }


  size ()
  {
    return this.group.size();
  }


  toArray ()
  {
    return this.group.toArray();
  }


  getKey ()
  {
    return this.key;
  }


  equals (rhs)
  {
    return this.key === rhs.key;
  }


};
